import React, { lazy, Suspense } from "react";
import ErrorBoundary from "./errorboundries"; // as above

const ImpactSection = lazy(() => import("./ImpactSection"));

function CleanUpMission() {
  return (
    <div className="bg-gradient-to-b from-blue-50 to-white min-h-screen font-sans w-full" style={{ borderRadius: "56px" }}>
      <header
        className="bg-blue-900 text-white py-8 px-6 shadow-xl"
        style={{ marginTop: "44px", borderRadius: "56px" }}
      >
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between text-center md:text-left gap-6">

          {/* Text Section */}
          <div className="md:w-2/3">
            <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight" style={{fontSize:"2rem"}}>
              Ocean Cleanup in Kasimedu
            </h1>
            <p className="text-lg mt-3 font-medium">
              <strong>Powered by Tamil Nadu Pollution Control Board</strong>
            </p>
          </div>

          {/* Image Section */}
          <div className="md:w-1/3 flex justify-center md:justify-end">
            <img
              src="/tnpcb.png"
              alt="TNPCB Logo"
              className="rounded-lg shadow-md w-40 md:w-48 h-auto object-contain"
              style={{width:"8rem"}}
            />
          </div>
        </div>
      </header>


      <main className="py-8 relative">
        <ErrorBoundary>
          <Suspense fallback={<div className="py-12 text-lg text-center text-blue-900 font-medium animate-pulse">Loading impact data...</div>}>
            <ImpactSection />
          </Suspense>
        </ErrorBoundary>
      </main>

      <footer className="bg-gray-900 text-white py-8 mt-14">
        <div className="container mx-auto px-4 flex flex-col items-center">
          <p className="text-base mb-3">Connect with us on social media</p>
          <div className="flex space-x-7">
            <a
              href="https://www.linkedin.com/company/recityindia"
              className="hover:scale-110 transition-transform"
              target="_blank" rel="noopener noreferrer"
              aria-label="Visit LinkedIn"
            >
              <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="LinkedIn" className="w-7 h-7 opacity-80 hover:opacity-100" />
            </a>
            <a
              href="https://www.facebook.com/recityindia"
              className="hover:scale-110 transition-transform"
              target="_blank" rel="noopener noreferrer"
              aria-label="Visit Facebook"
            >
              <img src="https://cdn-icons-png.flaticon.com/512/124/124010.png" alt="Facebook" className="w-7 h-7 opacity-80 hover:opacity-100" />
            </a>
            <a
              href="https://twitter.com/recityindia"
              className="hover:scale-110 transition-transform"
              target="_blank" rel="noopener noreferrer"
              aria-label="Visit Twitter"
            >
              <svg className="w-7 h-7 opacity-80 hover:opacity-100 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
          </div>
          <p className="text-xs mt-5 text-gray-400 font-mono">Let's clean the ocean together • v1.0.0</p>
        </div>
      </footer>
    </div>
  );
}

export default CleanUpMission;
